<div class="phone-input-label" *ngIf="label">
  <label>{{ label }} <span *ngIf="required" class="required">*</span></label>
</div>
<div class="phone-input-container">
  <p-dropdown
    [options]="paises"
    [ngModel]="ddi"
    (ngModelChange)="onDdiChange($event)"
    [filter]="true"
    filterBy="nome,ddi,sigla"
    [showClear]="false"
    appendTo="body"
    styleClass="ddi-dropdown"
    [panelStyleClass]="panelStyleClass"
    [style]="{ 'min-width': '130px', 'max-width': '155px' }">
    <ng-template pTemplate="selectedItem">
      <span class="ddi-selected">
        {{ ddi.bandeira }} {{ ddi.ddi }}
      </span>
    </ng-template>
    <ng-template let-pais pTemplate="item">
      <div class="ddi-item">
        <span class="ddi-item-bandeira">{{ pais.bandeira }}</span>
        <span class="ddi-item-nome">{{ pais.nome }}</span>
        <span class="ddi-item-codigo">{{ pais.ddi }}</span>
      </div>
    </ng-template>
  </p-dropdown>
  <input
    #telefoneInput
    type="tel"
    pInputText
    class="phone-number-input"
    [ngModel]="_telefoneExibido"
    (ngModelChange)="onTelefoneChange($event)"
    (input)="onTelefoneInput($event)"
    [placeholder]="placeholderAtual"
    [attr.maxlength]="ddi.mascara.length || 20"
    [ngClass]="inputStyleClass"
    [style]="inputStyle" />
</div>
